// extracted by mini-css-extract-plugin
export default {"SwitchControl":"SwitchControl_SwitchControl__cBaHU","label":"SwitchControl_label__rmU+Z","switch":"SwitchControl_switch__ATrqw"};